import { render, staticRenderFns } from "./LoginSave.vue?vue&type=template&id=a3116290&scoped=true"
import script from "./LoginSave.vue?vue&type=script&lang=js"
export * from "./LoginSave.vue?vue&type=script&lang=js"
import style0 from "./LoginSave.vue?vue&type=style&index=0&id=a3116290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3116290",
  null
  
)

export default component.exports